<template>
  <div v-if="item && $store.state.user.sections['subscriptions']">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>

    <div class="border" v-if="item.imeis && item.imeis.length">
      <div>
        <h3>LOCKMSISDN:</h3>

        <ul>
          <li v-for="(imei, i) in item.imeis" :key="i">
            <h5>
              IMEI: {{ imei.number }} <span v-if="imei.main">(Главный)</span>
            </h5>
            <code>
              <pre>
{
    "transaction": "{{ item.id }}",
	"imeis" : [
            {
              "number":"{{ imei.number }}",
              "command" : "lockMsisdn",
              "argument" : "{{ item.phone_control.replace("+", "") }}"
            }
	
	]
}  </pre
              >
            </code>
          </li>
        </ul>
      </div>
      <div>
        <h3>UNLOCKMSISDN:</h3>

        <ul>
          <li v-for="(imei, i) in item.imeis" :key="i">
            <h5>
              IMEI: {{ imei.number }} <span v-if="imei.main">(Главный)</span>
            </h5>
            <code>
              <pre>
{
    "transaction": "{{ item.id }}",
	"imeis" : [
            {
              "number":"{{ imei.number }}",
              "command" : "unlockMsisdn",
              "argument" : ""
            }
	
	]
}  </pre
              >
            </code>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "subscriptions",
    cardSetLink: "subscriptions",
    item: null,
    fields: [
      {
        key: "changeStauts",
        type: "hidden",
        default: "update",
      },

      {
        col: " col-12 col-md-6",
        key: "user_first_name",
        label: "Имя",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "user_last_name",
        label: "Фамилия",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "user_family_name",
        label: "Отчество",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "user_passport",
        label: "Номер паспорта",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "user_pinfl",
        label: "ПИНФЛ",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "user_email",
        label: "EMAIL",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "user_gender",
        labelKey: "user_gender",
        label: "Пол",
        type: "static_radio",
        default: "0",
        items: [
          { id: "1", title: "Мужской" },
          { id: "0", title: "Женский" },
        ],
      },
      {
        col: " col-12 col-md-6",
        key: "user_birthday",
        label: "Дата рождения",
        type: "field",
        textType: "date",
      },
      {
        col: " col-12 col-md-12",
        key: "user_address",
        label: "Адрес",
        type: "field",
        textType: "text",
      },

      {
        col: " col-12 col-md-12",
        key: "phone_control",
        label: "Номер по тарифу (ВЕРНО)",
        type: "mask",
        mask: "+998#########",
        default: "+998",
      },
      {
        col: " col-12 col-md-12",
        key: "phone_control_wrong",
        label: "Номер по тарифу (НЕВЕРНО)",
        type: "mask",
        mask: "+998#########",
        default: "+998",
      },
      {
        col: " col-12 col-md-6",
        key: "blank_number",
        label: "Номер бланка",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "blank_date",
        label: "Дата бланка",
        type: "field",
        textType: "date",
      },
      {
        col: " col-12 col-md-6",
        key: "start_date",
        label: "Дата начала договра",
        type: "field",
        textType: "date",
      },
      {
        col: " col-12 col-md-6",
        key: "end_date",
        label: "Дата окончания договра",
        type: "field",
        textType: "date",
      },
    ],
  }),

  props: ["id", "ticket_id"],

  async created() {
    this.fields.push({
      key: "ticket_id",
      type: "hidden",
      default: this.ticket_id,
    });
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      if (
        !this.$store.state.user.sections["tickets"] ||
        !this.$store.state.user.sections["subscriptions"]
      ) {
        alert("У вас нет доступа");

        return false;
      }

      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
